import { Msg } from '@advanza/advanza_generic'
import { Loading } from '@advanza/ui'
import { PopUpNotificationColumnsDef } from 'components/popUpNotifications/PopUpNotificationColumnsDef'
import PopUpNotificationsDataTable from 'components/popUpNotifications/PopUpNotificationsDataTable'
import { format } from 'date-fns'
import { usePopUpNotification } from 'hooks/popUpnotificationsHooks'
import { useEffect, useState } from 'react'

interface DateIntervalSpanProps {
    from: string
    to: string
}

export function DateIntervalSpan({ from, to }: DateIntervalSpanProps) {
    const fromDate = new Date(from)
    const toDate = new Date(to)

    return (
        <span>
            {format(fromDate, 'PPP')} → {format(toDate, 'PPP')}
        </span>
    )
}

const PopUpNotificationsList = () => {
    const { fetchPopUpNotifications, country } = usePopUpNotification()
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<boolean>(false)
    const [data, setData] = useState()

    useEffect(() => {
        let current = true
        setLoading(true)

        fetchPopUpNotifications()
            .then((items) => {
                if (!current) return
                setData(items)
                setLoading(false)
            })
            .catch((err) => {
                if (!current) return
                setError(err.message)
                setLoading(false)
            })

        return () => {
            current = false
        }
    }, [country])

    return (
        <>
            {loading && <Loading />}
            {error && <Msg type="error">{error}</Msg>}
            {data && (
                // Remounting on a country switch clears the table's own row, filter and expansion
                // state, which all belonged to the previous country's notifications.
                <PopUpNotificationsDataTable
                    key={country}
                    columns={PopUpNotificationColumnsDef}
                    data={data}
                />
            )}
        </>
    )
}

export default PopUpNotificationsList
